module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEUAAAAVfNQUfNQWfNQVfNMVfNQQgN8We9QWe9QVfNQUe9QTfNYQeNcVe9QVetUVetUWfNQ3YjzwAAAAEHRSTlMAwECA8NAQ4LCQb1AgoGAw7y0b3QAAAJFJREFUOMvljjkSAzEIBAfQvef/X2vK8mJXrUTgwIk7kDSoC8A/sQrdkBXGEc4B4TChWJFKJQvFhKuS+TkvXvkmcI8pTISoz5j1oIkQRJpaQ8GICeDxDva/B0fYgUWvudCYoytsItkVGKBvhHfXSBQsZBPqOUTgGxUfJH6x9Akbc8KYVHp3B23iC0ikgk9r+CEPuwIVJj7FBiEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/my/images/problem.png
// module id = bMHR
// module chunks = 0